import styled from 'styled-components';
import { motion } from 'framer-motion';
import { DownloadSimple, Swatches, ChartLine } from '@phosphor-icons/react';
import { Container } from '@/components/common/Container';
import { Section } from '@/components/common/Section';
import { theme } from '@/styles/theme';
import { staggerContainer, fadeInUp } from '@/styles/animations';

const Title = styled.h2`
  text-align: center;
  margin-bottom: ${theme.spacing.xxxl};
  color: ${theme.colors.text.black};
`;

const StepsWrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${theme.spacing.xl};
  position: relative;

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const StepCard = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${theme.spacing.lg};
`;

const StepNumber = styled.div`
  width: 64px;
  height: 64px;
  border-radius: ${theme.borderRadius.full};
  background: ${theme.colors.primary.main};
  color: ${theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.fontSizes['2xl']};
  font-weight: ${theme.fontWeights.bold};
`;

const StepIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: ${theme.borderRadius.medium};
  background: ${theme.colors.primary.extraLight};
  color: ${theme.colors.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StepTitle = styled.h3`
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.text.black};
  margin: 0;
`;

const StepDescription = styled.p`
  color: ${theme.colors.text.darkGray};
  margin: 0;
  line-height: 1.6;
`;

const steps = [
  {
    number: 1,
    icon: <DownloadSimple size={28} weight="duotone" />,
    title: 'Download & Choose',
    description: 'Pick your language and proficiency level',
  },
  {
    number: 2,
    icon: <Swatches size={28} weight="duotone" />,
    title: 'Swipe Daily',
    description: 'Practice for just 5 minutes',
  },
  {
    number: 3,
    icon: <ChartLine size={28} weight="duotone" />,
    title: 'Watch Your Vocabulary Grow',
    description: 'Track progress and build streaks',
  },
];

export const HowItWorksSection = () => {
  return (
    <Section $padding="large">
      <Container>
        <Title>Start learning in 3 simple steps</Title>
        <StepsWrapper
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {steps.map((step) => (
            <StepCard key={step.number} variants={fadeInUp}>
              <StepNumber>{step.number}</StepNumber>
              <StepIcon>{step.icon}</StepIcon>
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </StepCard>
          ))}
        </StepsWrapper>
      </Container>
    </Section>
  );
};
